import { forwardRef, useEffect, useState } from 'react';

export type EditorProps = import('./Editor').EditorProps;

export const EditorWrapper = forwardRef<any, EditorProps>((props, ref) => {
  const [Component, setComponent] = useState<React.ComponentType<any> | null>(
    null,
  );
  useEffect(() => {
    const loadComponent = async () => {
      const { Editor } = await import('./Editor');
      setComponent(Editor);
    };
    loadComponent();
  }, []);

  if (!Component) {
    return null;
  }

  return <Component ref={ref} {...props} />;
});
